import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface MetricViewPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class MetricViewPage extends Component<MetricViewPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.metric(this.props),
                    view: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}